<template>
  <v-card class="card pa-6 mx-auto" elevation="2">
    <div style="justify-content: center;" class="title px-2 d-flex align-center">
      <h2>{{ title }} - {{this.product.productName}}</h2>
    </div>
        
      <v-list shaped>
        <v-list-item-group v-model="selectedItem" color="normalred">
          <v-list-item v-for="(item, i) in history" :key="i">
            
            <v-icon :color="getColor(item.type)">{{item.icon}}</v-icon>
            <v-list-item-content>
              <v-list-item-title>{{item.date}} - {{item.text}}</v-list-item-title>
              
            </v-list-item-content>
           
          </v-list-item>
        </v-list-item-group>
      </v-list>

    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn
            large
            class="cancelBtn black--text"
            @click="close"
            :loading="loading"
          >
            <span>{{ cancelBtn }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
.title{
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 1.0rem !important;
  line-height: 2.6rem;
  text-align: center;
  color:black;
}
.card {
  background: #ffffff !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 8px !important;
}

.cancelBtn {
  font-weight: bold !important;
  background-color: #ffffff !important;
  border: 1.5px solid #2d3038 !important;
  box-sizing: border-box !important;
  border-radius: 6px !important;
}

.okBtn {
  font-weight: bold !important;
  box-sizing: border-box !important;
  background: #2d3038 !important;
  border-radius: 6px solid #2d3038 !important;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 29px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #232021;
}

.observation {
  font-family: Roboto;
  font-style: normal;
  color: grey;
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #232021;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";

export default {
  name: "ExcelModal",

  props: {
    filter: Object,
    title: String,
    cancelBtn: String,
    icone: String,
    product: Object,
    category: Object,
    quantidade: Number,
  },

  data: () => ({
    selectedItem: 0,
    history: [
      { date:"10/09/2021", text: "Produto Inativado", icon: "mdi-close-box", type:"delete", },
      { date:"09/09/2021", text: "Produto Editado", icon: "mdi-comment-edit", type:"edit", },
      { date:"03/09/2021", text: "Produto Editado", icon: "mdi-comment-edit", type:"edit", },
      { date:"30/08/2021", text: "Estoque menos 100: 1400", icon: "mdi-arrow-down-circle", type:"down", },
      { date:"13/08/2021", text: "Estoque de 0 para 1500", icon: "mdi-arrow-up-circle", type:"up", },
      { date:"02/08/2021", text: "Produto Inativado", icon: "mdi-close-box", type:"delete", },
      { date:"21/07/2021", text: "Produto Editado", icon: "mdi-comment-edit", type:"edit", },
      { date:"11/07/2021", text: "Produto Editado", icon: "mdi-comment-edit", type:"edit", },
      { date:"01/07/2021", text: "Produto Cadastrado", icon: "mdi-sticker-plus", type:"add", },

    ],
    loading: false,
    excelDialog: "",
    apiService: new ApiService(),
  }),

  methods: {
    getColor(type){

      switch (type){
        case 'up':
          return 'green'
          break

        case 'down':
          return 'normalred'
          break
        case 'add':
          return 'blue'
          break
        case 'edit':
          return 'black'
          break
        case 'delete':
          return 'normalred'
          break
        default:
          return 0;
      }


    },

    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },
  },
};
</script>
